exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer-assets-container{height:420px}.outer-assets-container .image-container .magnifier>img{max-width:100%;max-height:420px}@media only screen and (max-width:992px){.outer-assets-container .image-container{margin:0 auto}.outer-assets-container .image-container .magnifier>img{max-width:100%;max-height:300px}}.outer-assets-container .video-container{top:50%;position:relative;min-height:420px;max-height:420px}.outer-assets-container .video-container video{-webkit-transform:translateY(-50%);transform:translateY(-50%)}@media only screen and (max-width:992px){.outer-assets-container{height:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d881288","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Resources/assets/js/UI/components/image-magnifier.vue
// module id = C/bQ
// module chunks = 0